/**
 * Routes: /news/ and below
 *
 * Will me merged into the router's 'route' array
 */
import NewsList from '@/views/auth/admin/NewsList.vue'
import NewsForm from '@/views/auth/admin/NewsForm.vue'
export default [
    {
        path: '/news',
        name: 'news',
        component: NewsList,
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            title: 'News',
        },
        children: [
            {
                path: ':id',
                name: 'news_edit',
                component: NewsForm,
                meta: {
                    requiresAuth: true,
                    requiresAdmin: true,
                    title: (to: { params: { id: number | string } }) =>
                        `News Eintrag: ${to.params.id}`,
                },
            },
        ],
    },
]
